export default __webpack_public_path__ + "static/media/vongole9.70ebde83.jpg";